import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-lagerort-list-view',
  imports: [],
  templateUrl: './lagerort.list-view.html',
  styleUrls: ['./lagerort.list-view.css'],
})
export class LagerortListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
